import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { motion } from 'framer-motion';
import { Home, ArrowLeft } from 'lucide-react';
import PageBanner from '../components/PageBanner';

const NotFound = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-white text-gray-900 font-sans selection:bg-red-100 min-h-screen flex flex-col mt-20 lg:mt-[120px]">
            {/* 404 Hero Section */}
            <div className="relative flex-grow flex items-center justify-center overflow-hidden bg-slate-50 py-20">


                <div className="container mx-auto px-6 relative z-10 text-center">
                    <motion.h1
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.8, ease: "backOut" }}
                        className="text-[10rem] md:text-[15rem] font-black text-slate-200 leading-none select-none"
                    >
                        404
                    </motion.h1>

                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        className="-mt-12 md:-mt-20 relative"
                    >
                        <h2 className="text-4xl md:text-6xl font-bold mb-6 text-slate-900">
                            Page Not Found
                        </h2>
                        <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-10 font-light">
                            The road you are looking for seems to have ended. Let's get you back on track to your next adventure.
                        </p>

                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <Link to="/">
                                <Button className="bg-red-600 hover:bg-red-700 text-white rounded-full px-8 py-6 text-lg font-bold shadow-lg shadow-red-200 hover:shadow-red-300 transition-all duration-300 hover:scale-105 flex items-center gap-2">
                                    <Home size={20} />
                                    Return Home
                                </Button>
                            </Link>
                            <Button
                                variant="outline"
                                onClick={() => window.history.back()}
                                className="border-slate-300 text-slate-700 hover:bg-slate-100 rounded-full px-8 py-6 text-lg font-bold transition-all duration-300 flex items-center gap-2"
                            >
                                <ArrowLeft size={20} />
                                Go Back
                            </Button>
                        </div>
                    </motion.div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
